import React from 'react';
import {useIntl} from 'react-intl';
import {useParams, useNavigate} from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import {AppDownloadIconButton} from '../../../../Core/buttons/AppDownloadIconButton/AppDownloadIconButton';
import IFrameEventNotifications from '@utils/iFrameNotifyer/IFrameEventNotifications';
import {DOCUMENT_NAVIGATION_STARTED_EVENT} from '@utils/iFrameNotifyer/events';
import {CEREMONY_DOCUMENT_PATH} from '@constants/routes';
import './document.less';

export default function Document({
    document,
    icon,
    status,
    onDownload,
    remainingActions,
    isDownloadAllowed
}) {
    const intl = useIntl();
    const navigate = useNavigate();
    const {documentId} = useParams();
    const isCurrentDocument = document.id === documentId;
    const iFrameEventNotifications = IFrameEventNotifications.getInstance();

    async function selectDocument() {
        await iFrameEventNotifications.postEvent(DOCUMENT_NAVIGATION_STARTED_EVENT);
        navigate(`${CEREMONY_DOCUMENT_PATH}/${document.id}`);
    }

    return (
        <ListItem
            selected={isCurrentDocument}
            classes={{root: 'signing-menu-document-container'}}
            button
            disableGutters
            onClick={selectDocument}
        >
            <div className="signing-menu-document-info">
                <div className="name-container">
                    {document.name}
                </div>
                <div className="status-container">
                    {icon}
                    <div className="status">
                        {intl.formatMessage({id: status, defaultMessage: ''})}
                    </div>
                    {remainingActions > 0 && (
                        <div className="actions-required">
                            {intl.formatMessage({id: 'oss.components.SideBar.Document.actionsRequired', defaultMessage: ''}, {
                                actionsCount: remainingActions
                            })}
                        </div>
                    )}
                </div>
                <div className="pages">
                    {intl.formatMessage({id: 'oss.components.SideBar.Document.pages', defaultMessage: ''}, {
                        pageCount: document.pages.length
                    })}
                </div>
            </div>
            {isDownloadAllowed && (
                <ListItemSecondaryAction classes={{root: 'document-download-btn-container'}}>
                    <AppDownloadIconButton
                        onClick={onDownload}
                    />
                </ListItemSecondaryAction>
            )}
        </ListItem>
    );
}
